<template>
  <footer id="footer" class="footer bg-greycolor">
    <div class="py-1 footer-width">
      <div class="row mt-32">
        <div class="col-lg-6">
          <img
            class="footer-brand img-fluid"
            src="../assets/images/Starbucks_GlobalAcademy_lockup_horizontal_FINAL-01_(1).svg"
            alt="logo"
          >
        </div>
        <div class="col-lg-6">
          <div class="py-4 font-black">
          <strong
            class="footer-info font-paragraph"
          >Starbucks Coffee Academy is a learning journey created by Starbucks Coffee Company and available through Starbucks Global Academy, powered by Arizona State University.</strong>
        </div>
          <div class="row center-content flex-nowrap px-4">
            <div class="col- mr-1">
              <a href="https://itunes.apple.com/us/app/starbucks-global-academy/id1200272516?mt=8"  target="_blank" rel="noopener noreferrer" class="nav-link">
                <img src="../assets/images/apple.svg" alt="Download our app on the App store!" srcset class="image-footer-1 img-fluid">
              </a>
            </div>
            <div class="col-">
              <a href="https://play.google.com/store/apps/details?id=com.starbucksglobalacademy.courses&hl=en_US"  target="_blank" rel="noopener noreferrer" class="nav-link">
              <img src="../assets/images/google-play.svg" alt="Download our app on the Google Play store!" srcset style="width:8.3rem" class="image-footer-2 pl-0 img-fluid">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "FooterComponent"
};
</script>
